// @ts-ignore
import ReactLinkify from 'react-linkify';
import React from 'react';
import {
    processShortEmojiMessage,
    stylingGapFill,
} from 'flow/utils/message-utils';
import {
    MessageStyling,
    ConversationMessageKey,
} from 'flow/types/TicketEventData';
import { TicketKey } from 'flow/types/EntityKeys';
import { TypedMap } from 'flow/types/TypedMap';
import InternalNoteMention from './InternalNoteMention';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectEventMessageStylings,
    selectEventMessageText,
} from 'flow/selectors/TicketEventSelectors';

interface Props {
    ticketKey: TicketKey;
    messageKey: ConversationMessageKey;
}

const MessageStyled = ({ ticketKey, messageKey }: Props) => {
    const messageText = useAppSelector((state) =>
        selectEventMessageText(state, ticketKey, messageKey),
    );
    const messageStylings = useAppSelector((state) =>
        selectEventMessageStylings(state, ticketKey, messageKey),
    );
    if (!messageText) return null;

    const gapFilled = stylingGapFill(messageStylings, messageText.length);
    const getStyledElement = (stylingReference: any, text: string) => {
        if (stylingReference?.has('chatUser')) {
            return (
                <InternalNoteMention
                    name={text}
                    userKey={stylingReference.getIn(['chatUser', 'key'])}
                />
            );
        }
        return (
            <ReactLinkify
                properties={{
                    target: '_blank',
                    rel: 'nofollow noopener noreferrer',
                    className: 'text-link',
                }}
            >
                {text}
            </ReactLinkify>
        );
    };

    const styled = gapFilled.map((styling: TypedMap<MessageStyling>) => {
        const startPosition = styling.get('startPosition');
        const length = styling.get('length');
        return getStyledElement(
            styling.get('stylingReference'),
            messageText?.substring(startPosition, startPosition + length),
        );
    });

    const styledMessageBody = React.Children.toArray(styled.toArray());
    return processShortEmojiMessage(messageText, messageKey, styledMessageBody);
};

export default React.memo(MessageStyled);
